// extracted by mini-css-extract-plugin
export default {"topPanel":"TopPanel_topPanel__sVQWA","container":"TopPanel_container__00-st","currentPage":"TopPanel_currentPage__5NhmU","button":"TopPanel_button__Swwvo"};